var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.hasFirstYearOffer)?_c('tooltip',{staticClass:"annual-fee-tooltip",attrs:{"tooltip-text":_vm.$translate('annual_fee_offer_tooltip', '')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }